<template>
  <vs-popup class="select-agreement-popup" title="Select Agreement" :active.sync="selectAgreementPopup">
    <div id="ag-grid-demo">
      <div id="grid-loader" class="vx-card vs-con-loading__container p-0">
        <ag-grid-vue
          id="myGrid"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 mb-4 ag-grid-table ag-agt-list"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="filteredTableData"
          components="components"
          rowSelection="multiple"
          :enableRangeSelection="true"
          :suppressCopyRowsToClipboard="true"
          colResizeDefault="shift"
          :suppressDragLeaveHidesColumns="true"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :suppressRowClickSelection="true"
          :rowClassRules="rowClassRules"
          :statusBar="statusBar"
          :sideBar="sideBar"
          :rowHeight="45"
          :headerHeight="30"
          :floatingFiltersHeight="45"
          :checkboxSelection="true"
          :domLayout="domLayout"
          @row-selected="onRowSelected"
          @column-resized="onColumnResized"
        >
        </ag-grid-vue>
        <div class="select-action-btns flex justify-end pb-2 px-6">
          <vs-button
            @click="getSelectedAgt()"
            color="primary"
            type="filled"
            :disabled="this.counter == 0"
            >Attach Agreement
          </vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

export default {
  name: "selectAgreement",
  components: {
    AgGridVue,
  },
  props: {
    registrar: {
      type: [Object, Array],
    },
    reseller: {
      type: [Object, Array],
    },
    selectedGeneralAgreements: {
      type: [Object, Array]
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      counter: 0,
      selectAgreementPopup: false,
      selectedAgtId: [],
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filter: false,
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      rowSelection: null,
      columnDefs: [
        {
          headerName: "Year",
          field: "year",
          filter: "agSetColumnFilter",
          width: 130,
          checkboxSelection: true,
        },
        {
          headerName: "Partner",
          field: "partner_name",
          filter: "agSetColumnFilter",
          minWidth: 150,
        },
        {
          headerName: "Agreements",
          field: "filename",
          filter: "agSetColumnFilter",
          minWidth: 300,
          width: 300,
          cellRenderer: (data) => {
            return (
              "<a href=" +
              data.data.dropbox_link +
              " target='_blank' class='cellAgtName'>" +
              data.data.filename +
              "</a>"
            );
          },
        },
        {
          headerName: "Start Date",
          field: "start_date",
          filter: "agDateColumnFilter",
          minWidth: 175,
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = cellValue;
              if (dateAsString == null) return -1;
              let dateParts = dateAsString.split("-");
              let cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          },
        },
        {
          headerName: "End Date",
          field: "end_date",
          filter: "agDateColumnFilter",
          minWidth: 175,
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = cellValue;
              if (dateAsString == null) return -1;
              let dateParts = dateAsString.split("-");
              let cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          },
        },
      ],
      domLayout: null,
      tableData: [],
      components: {},
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },

    selectAgreementPopup(val) {
      if (val == false) {
        setTimeout(() => {
          this.gridApi.deselectAll();
        }, 100);
      } else {
        this.populateTableData();
      }
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 500;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },

    formatedRegistrar() {
      if (Array.isArray(this.registrar)) {
        var registrarName = this.registrar.map((x) => {
          return x.unique_registrar_id;
        });
      } else {
        var registrarName = [this.registrar.unique_registrar_id];
      }
      return registrarName;
    },

    formatedReseller() {
      if (Array.isArray(this.reseller)) {
        var resellerName = this.reseller.map((x) => {
          return x.value;
        });
      } else {
        var resellerName = [this.reseller.value];
      }
      return resellerName;
    },

    filteredTableData() {
      var concatData = [];
      if (this.formatedRegistrar.length) {
        var filterRegistrarData = this.tableData.filter((x) => 
          this.formatedRegistrar.includes(x.unique_registrar_id)
        );
        // console.log('filterRegistrarData', JSON.stringify(filterRegistrarData));
        concatData = [...concatData, ...filterRegistrarData];
        // return filterRegistrarData;
      }
      if (this.formatedReseller.length) {
        // console.log('this.tableData :>> ', this.tableData, this.formatedReseller);
        var filterResellerData = this.tableData.filter((x) => {
            // console.log('x.new_reseller_id :>> ', x.new_reseller_id);
            return this.formatedReseller.includes(x.new_reseller_id)
          }
        );
        // console.log('filterResellerData', JSON.stringify(filterResellerData));
        concatData = [...concatData, ...filterResellerData];
      }

      // Remove duplicate IDs from the array
      const uniqueIds = [];

      let unique = concatData.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.id);

        if (!isDuplicate) {
          uniqueIds.push(element.id);

          return true;
        }

        return false;
      });

      // let unique = concatData;

      // Filter out selected general agreements for Add Promo screen
      if(this.selectedGeneralAgreements && this.selectedGeneralAgreements.length > 0) {
        let selectedAgreementIds = this.selectedGeneralAgreements.map(el => el.value);

        unique = unique.filter(el => selectedAgreementIds.indexOf(el.id) == -1);
      }

      return unique;
    },
  },
  methods: {
    openSelectAgtPopup() {
    console.log('openSelectAgtPopup');
      this.selectAgreementPopup = true;
      this.populateTableData();
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("domain", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("domain", "left");
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },

    setAutoHeight() {
      this.gridApi.setDomLayout("autoHeight");
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector("#myGrid").style.height = "";
    },

    populateTableData() {
      console.log('Select Agreement data populated');
      
      let self = this;

      /* Get table data for std-promo-req */
      this.$axiosSecure
        .get("/agreements/approved")
        .then((response) => {
          // this.tableData = response.data;
          for (var key in response.data) {
            if (response.data[key].unique_registrar_id) {
              response.data[key].partner_name =
                response.data[key].unique_registrar.name;
            } else {
              response.data[key].partner_name =
                response.data[key].new_reseller.name;
            }
          }

          // Split by dropbox detail
          var tempTableData = [];
          response.data.forEach(x => {
              x.dropbox_detail.forEach(y => {
              tempTableData.push({
                ...x,
                attached_agt_id: y['id'],
                filename: y['filename'],
                dropbox_link: y['dropbox_link'],
                path: y['path']
              })
            })
          })

          this.tableData = tempTableData;
        })
        .catch((error) => {
          // Error notification
          self.$vs.notify({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin",
          });

          console.log(error);
        });
    },

    getSelectedAgt() {
      var selectedRowData = this.gridApi.getSelectedNodes().map((x) => x.data);
      selectedRowData = selectedRowData.map(x => {
        x.id = x.attached_agt_id;
        return x;
      })
      var selectedAgtId = selectedRowData.map((x) => {
        return {
          label: x.filename,
          link: x.dropbox_link,
          value: x.attached_agt_id,
        };
      });
      if (this.edit) {
        this.$root.$emit("selectedAgtsForEdit", selectedRowData);
      } else {
        this.$root.$emit("selectedAgts", selectedAgtId);
      }
      this.selectAgreementPopup = false;
    },

    onRowSelected(event) {
      if (event.node.selected) {
        // Push to selectedPromos
        // console.log('lenght', this.gridApi.getSelectedNodes().length);
        this.counter = this.gridApi.getSelectedNodes().length;
      } else {
        // Remove from selectedPromos
        // console.log('lenght', this.gridApi.getSelectedNodes().length);
        this.counter = this.gridApi.getSelectedNodes().length;
      }
    },
  },
  beforeMount() {
    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    // Set Grid sidebar
    this.sideBar = {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true,
          },
        },
      ],
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    //set Auto height
    this.setAutoHeight();
    // Resize to fit columns
    this.sizeColumnsToFit();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    // Page Refresh Event
    this.$root.$on("refreshPage", () => {
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    });

    this.$root.$on("openSelectAgtList", () => {
      this.selectAgreementPopup = true;
    });
  },
  destroyed() {
    // Clear Listing Count
    this.$store.dispatch("clearListingCount");

    // Unbind Button Event Listeners
    this.$root.$off("refreshPage");
    this.$root.$off("openSelectAgtList");
  },
};
</script>
<style>
.ag-agt-list .ag-body-viewport {
  height: 300px;
  overflow: auto;
}
.ag-theme-material .ag-filter .ag-filter-header-container {
  margin-bottom: 6px;
}
/* .con-vs-popup {
  z-index: 530000000;
} */
</style>

